import { ContractTypes, Roles, Status } from "app/models/user"
import { FilterActionResult } from "../filter/filter.actions"
import createFilterReducer, { DEFAULT_STATE, FilterableEntities } from "../filter/filter.reducer"

export type TemplateWeekAvailabilitiesFilter = {
  [k: string]: string[] | string | undefined
  q: string | undefined
  contract_type: ContractTypes | undefined
  functions?: string[]
  roles?: Roles[]
}

const INITIAL_STATE = {
  ...DEFAULT_STATE,
  filterableFields: {
    contract_type: [ContractTypes.PAYROLL, ContractTypes.EXTERNAL],
    functions: [],
    roles: [Roles.Planner, Roles.HROfficer, Roles.User],
    status: [Status.Inactive, Status.Active],
  },
  filters: { q: undefined, contract_type: undefined, status: undefined, functions: [], roles: [] },
}

const templateWeekAvailabilitiesFilterReducer = (
  state = INITIAL_STATE,
  action: FilterActionResult<TemplateWeekAvailabilitiesFilter>,
) => createFilterReducer<TemplateWeekAvailabilitiesFilter>(FilterableEntities.AvailabilitiesWeek)(state, action)

export default templateWeekAvailabilitiesFilterReducer
